import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { MOBILE_UI } from '../../constants/mobileUi';

/** Labelled group inside a BottomSheet: section title, optional hint, then the control. */
const SheetSection = ({ title, hint, children }) => {
  const { colors } = useTheme();
  return (
    <div style={{ marginBottom: MOBILE_UI.sectionGap }}>
      <div
        style={{
          fontSize: MOBILE_UI.font.section,
          fontWeight: 700,
          color: colors.text,
          marginBottom: hint ? 2 : 8,
        }}
      >
        {title}
      </div>
      {hint ? (
        <div style={{ fontSize: 12, color: colors.textMuted, marginBottom: 8 }}>{hint}</div>
      ) : null}
      {children}
    </div>
  );
};

export default SheetSection;
